const categoryColor = [
    "#EDF0ED", "#E3C8B4", "#A4C1D6", "#F6C4D8", "#83CBFD",
    "#C8B9CB", "#E4F4C1", "#FFF0EF", "#A09296", "#E19EB8",
    "#909E9D", "#F28E72", "#FF6458", "#F25087", "#D657EC",
    "#B48CFC", "#8C9AE8", "#4EAEFB", "#49D7E9", "#38CBBD",
    "#4CAF50", "#8BC34A", "#FFEB3B", "#FFC107", "#FF9800",
    "#B75B5B", "#C584E3", "#3FC8E7", "#E91E1E", "#7B91BB"
]

export default categoryColor;